import { useAuthStore } from '@stores/auth';

export default defineNuxtRouteMiddleware(async (to) => {
    if (to.meta.skipLocalesMiddleware) return;

    const { user } = useAuthStore();
    if (user) {
        const { $i18n } = useNuxtApp();
        if (user.lang === $i18n.locale.value) return;

        await $i18n.setLocale(user.lang || 'en');
    }
});
